import { useContext } from 'react';
import { UnitLocationStoreContext } from './unit-location-store-context';
import { UnitLocationStore } from './unit-location-store';

export function useUnitLocationStore(): UnitLocationStore | undefined {
    return useContext(UnitLocationStoreContext);
}
